<template>
  <div class="recordsView">
    <!-- <div class="box-header">
      <div class="header-back" @click="goBack">
        <i class="el-icon-arrow-left"></i>
        返回
      </div>
    </div> -->
    <div class="contentWrap">
      <div class="filterContent">
        <!-- 头部筛选 -->
        <el-form :inline="true" :model="form">
          <el-form-item label="原负责人:">
            <el-select
              v-model="form.old_principal"
              class="recordsSelect"
              popper-class="records-mySelectOptions"
              filterable
              remote
              clearable
              placeholder="请输入原负责人姓名"
              :remote-method="remoteOldPrincipalMethod"
              :loading="remoteOldPrincipalLoading"
              @clear="oldPrincipalOptions = []"
            >
              <el-option
                v-for="item in oldPrincipalOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                <p class="labelText">{{ item.label }}</p>
                <p class="weakText">{{ item.info }}</p>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="原负责人ID:" style="margin-bottom: 30px">
            <el-input
              v-model="form.old_principal_userid"
              :clearable="true"
              placeholder="请输入原负责人ID"
            ></el-input>
          </el-form-item>
          <el-form-item label="新负责人:">
            <el-select
              class="recordsSelect"
              v-model="form.new_principal"
              popper-class="records-mySelectOptions"
              filterable
              remote
              clearable
              placeholder="请输入新负责人姓名"
              :remote-method="remoteNewPrincipalMethod"
              :loading="remoteNewPrincipalLoading"
              @clear="newPrincipalOptions = []"
            >
              <el-option
                v-for="item in newPrincipalOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                <p class="labelText">{{ item.label }}</p>
                <p class="weakText">{{ item.info }}</p>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="新负责人ID:" style="margin-bottom: 30px">
            <el-input
              v-model="form.new_principal_userid"
              :clearable="true"
              placeholder="请输入新负责人ID"
            ></el-input>
          </el-form-item>
          <el-form-item label="客户姓名:" style="margin-bottom: 30px">
            <el-input
              v-model="form.customer_name"
              :clearable="true"
              placeholder="请输入客户姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="医院:" style="margin-bottom: 30px">
            <el-input
              v-model="form.hospital_name"
              :clearable="true"
              placeholder="请输入医院名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="科室:" style="margin-bottom: 30px">
            <el-select v-model="form.department_name" clearable placeholder="请选择科室名称">
              <el-option
                v-for="item in departmentOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="医生:" style="margin-bottom: 30px">
            <el-input
              v-model="form.doctor_name"
              :clearable="true"
              placeholder="请输入医生名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="分配日期:">
            <el-date-picker
              unlink-panels
              v-model="date"
              type="daterange"
              class="release-select-time"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :editable="false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button class="filterButton" type="primary" @click="onSubmit">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 表格 -->
      <div class="listContent">
        <el-table
          v-loading="loading"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          header-row-class-name="headerClass"
        >
          <template slot="empty">
            <!-- 没有数据 -->
            <NoData></NoData>
          </template>
          <el-table-column prop="customer_name" label="客户名称"></el-table-column>
          <el-table-column prop="doctor_name" label="医生"></el-table-column>
          <el-table-column prop="hospital_name" label="医院" width="300"></el-table-column>
          <el-table-column prop="department_name" label="科室"></el-table-column>
          <el-table-column prop="old_principal" label="原负责人"></el-table-column>
          <el-table-column
            prop="old_principal_userid"
            label="原负责人ID"
            width="100"
          ></el-table-column>
          <el-table-column prop="new_principal" label="新负责人"></el-table-column>
          <el-table-column
            prop="new_principal_userid"
            label="新负责人ID"
            width="100"
          ></el-table-column>
          <el-table-column prop="status" label="转接状态">
            <template slot-scope="scope">
              <span>{{ scope.row.status === 1 ? '成功' : '失败' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="分配时间" width="180">
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.create_time
                    ? dateFormat(
                        new Date(scope.row.create_time.slice(0, -1)),
                        'YYYY-MM-dd HH:mm:SS',
                      )
                    : '--'
                }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="tableData.length > 0"
          class="pagination"
          style="background-color: #ffffff"
          layout="total, prev, pager, next, jumper"
          :total="total"
          :page-size="size"
          :current-page="currentPage"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { dateFormat } from '@/utils/time';
import {
  getTransferRecordListApi,
  getPrincipalInfoListApi,
  getDeparturePrincipalListApi,
} from '@/api/enterpriseWeChatManagement';
import { getHospitalDepartmentListApi } from '@/api/setUp';
import NoData from '@/components/no-data';
export default {
  name: 'Records',
  components: {
    NoData,
  },
  props: {
    // customType: {
    //   type: Number,
    //   default: 0,
    // },
  },
  data() {
    return {
      customType: 0,
      dateFormat,
      form: {
        doctor_name: '',
        hospital_name: '',
        department_name: '',
        customer_name: '',
        old_principal: '',
        old_principal_userid: '',
        new_principal: '',
        new_principal_userid: '',
      },
      date: [],
      remoteOldPrincipalLoading: false,
      remoteNewPrincipalLoading: false,
      tableData: [],
      currentPage: 1 /* 当前页面数 */,
      size: 20 /* 当前页面显示数目 */,
      total: 0 /* 总数 */,
      oldPrincipalOptions: [],
      newPrincipalOptions: [],
      loading: false,
      breadcrumb: [
        {
          menu_name: '企业微信管理',
        },
        {
          menu_name: '外部联系人管理',
          menu_path: 'externalContactManagement',
        },
      ],
      tabMap: {
        allocated: '已分配客户',
        waitForDistribution: '待分配客户',
      },
      departmentOptions: [],
    };
  },
  created() {
    const { tab } = this.$route.query;
    this.breadcrumb.push({
      menu_name: this.tabMap[tab],
      menu_path: 'externalContactManagement',
      menu_params: { tab },
    });
    this.breadcrumb.push({
      menu_name: '查看分配记录',
    });
    this.g_breadcrumb(this.breadcrumb);
    this.customType = this.$route.query.customType;
    this.getTableData();
    this.getDepartmentList();
  },
  methods: {
    goBack() {
      this.$emit('goBack');
    },
    /* 切换分页 */
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
    async getDepartmentList() {
      try {
        const res = await getHospitalDepartmentListApi({
          hospital_id: 0,
          page_index: 0,
          page_size: 0,
        });
        if (res.data && res.data.length) {
          this.departmentOptions = res.data.map((item) => ({
            label: item.department_name,
            value: item.department_name,
          }));
        }
      } catch (err) {
        console.log('error', err);
      }
    },
    async getTableData() {
      this.loading = true;
      const params = {
        ...this.form,
        custom_type: this.customType, // 记录类型 (0已分配客户 1待分配客户)
        start_time:
          this.date && this.date.length ? this.dateFormat(this.date[0], 'YYYY-MM-dd') : '',
        end_time: this.date && this.date.length ? this.dateFormat(this.date[1], 'YYYY-MM-dd') : '',
        page: this.currentPage,
        limit: this.size,
      };

      try {
        const res = await getTransferRecordListApi(params);
        this.tableData = res.list;
        this.total = res.total;
      } catch (err) {
        this.tableData = [];
        this.total = 0;
        this.$message.error(`${err.message || '请求失败'}`);
      }
      this.loading = false;
    },
    /* 搜索 */
    onSubmit() {
      this.currentPage = 1;
      this.getTableData();
    },
    /* 离职负责人列表 */
    async getDeparturePrincipalList(name = '') {
      const params = {
        principal: name,
      };
      try {
        const res = await getDeparturePrincipalListApi(params);
        let principalOptions = [];
        if (res.list.length) {
          principalOptions = res.list.map((item) => ({
            label: item.principal,
            info: item.principal,
            value: item.principal,
          }));
        }
        return Promise.resolve(principalOptions);
      } catch (err) {
        return Promise.resolve([]);
      }
    },
    /* 负责人列表 */
    async getPrincipalInfo(name = '') {
      const params = {
        name,
      };
      try {
        const res = await getPrincipalInfoListApi(params);
        let principalOptions = [];
        if (res.list.length) {
          principalOptions = res.list.map((item) => ({
            label: item.name,
            info: item.department_name,
            value: item.name,
          }));
        }
        return Promise.resolve(principalOptions);
      } catch (err) {
        return Promise.resolve([]);
      }
    },
    remoteOldPrincipalMethod(query) {
      if (query === '') {
        this.oldPrincipalOptions = [];
        return;
      }
      this.remoteOldPrincipalLoading = true;
      const method =
        this.customType === '0' ? this.getPrincipalInfo : this.getDeparturePrincipalList;
      method(query).then((res) => {
        this.oldPrincipalOptions = res;
        this.remoteOldPrincipalLoading = false;
      });
    },
    remoteNewPrincipalMethod(query) {
      if (query === '') {
        this.newPrincipalOptions = [];
        return;
      }
      this.remoteNewPrincipalLoading = true;
      this.getPrincipalInfo(query).then((res) => {
        this.newPrincipalOptions = res;
        this.remoteNewPrincipalLoading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.recordsView {
  .box-header {
    height: 80px;
    padding: 37px 23px 21px;
    color: #606266;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    background: #fff;
    .header-back {
      cursor: pointer;
      display: inline-block;
      .el-icon-arrow-left {
        font-weight: bold;
      }
    }
    .header-back:hover {
      color: rgb(47, 150, 255);
    }
  }
  .contentWrap {
    padding: 0 30px;
    .filterContent {
      padding: 30px 0;
      border-bottom: 1px solid #eee;
      // ::v-deep.el-form-item {
      //   margin-bottom: 0;
      // }
      // .recordsSelect {
      //   ::v-deep.el-input__inner {
      //     width: 200px;
      //   }
      // }
    }

    .listContent {
      // ::v-deep.el-table {
      //   border: 1px solid #ebeef5;
      //   border-bottom: none;
      //   .headerClass {
      //     background: #f5f7fa;
      //   }
      // }
      ::v-deep.pagination {
        text-align: right;
        margin: 10px 0;
      }
    }
  }
}
</style>
<style lang="scss">
// .records-mySelectOptions {
//   ::v-deep.el-select-dropdown__item {
//     height: 57px;
//     text-overflow: initial;
//     white-space: initial;
//     .labelText {
//       font-family: PingFangSC-Regular;
//       font-size: 16px;
//       color: #303133;
//     }
//     .weakText {
//       font-family: PingFangSC-Regular;
//       font-size: 14px;
//       color: #909399;
//       line-height: 14px;
//       overflow: hidden;
//       text-overflow: ellipsis;
//       white-space: nowrap;
//     }
//   }
// }
//
</style>
